import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DadosOcorrenciaCnab240, Ocorrencia, TTitulosCnab240 } from "../../../../../../../types/api/financeiro/detalhar-integracao-bancaria";
import moment from "moment";
import { useEffect, useState } from "react";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import DataSemResultados from "../../../../../../../components/DataSemResultados";
import { ModalDetalheTituloProvider } from "../../../../MIContasReceber/ModalDetalheTituloContext";
import { darken } from '@mui/material/styles';
import DialogAnalisarTitulosCnab240 from "./DialogAnalisarTitulosCnab240";

export default function TableDadosCNAB240({
    tipo,
    rows,
    somenteVisualizacao,
    handleAlterarLinha
}: TTableDadosCNAB240Props) {

    const [openModalTitulo, setOpenModalTitulo] = useState<IOpenModal | null>(null)
    const [dadosProcessados, setDadosProcessados] = useState<Ocorrencia[]>([])

    useEffect(() => {
        if (rows && rows.length > 0) {
            setDadosProcessados(rows);
        }
    }, [rows]);

    const rowsToRender = dadosProcessados.length > 0 ? dadosProcessados : (rows?.length > 0 ? rows : []);

    return (
        <Box width='100%'>
            <TableContainer sx={{ maxHeight: "74vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Seu número</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Data pagamento</b></TableCell>
                            <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}><b>Valor do boleto</b></TableCell>
                            <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}><b>Valor Simulado</b></TableCell>
                            <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}><b>Valor Recebido</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Nome</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Ocorrência</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Resposta</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Status</b></TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}><b>Título</b></TableCell>
                        </TableRow>
                    </TableHead>

                    {
                        rowsToRender.length > 0 &&
                        <TableBody>
                            {rowsToRender.map((row) => {
                                const tituloResposta = row.resumo_dados.resposta
                                const status = row.status
                                let permitirEditar = true;
                                const resumo = row.resumo_dados as DadosOcorrenciaCnab240
                                const saldoSimuladoArredondado = Math.round((resumo.titulos_possiveis?.reduce((acc, curr) => acc + curr.saldo_simulado, 0) ?? 0) * 100) / 100;

                                let colorBg = ''
                                if (status === "Aguardando finalização") colorBg = "#e5f6fd"
                                if (status === "Conflito encontrado") colorBg = "#fff9e6"
                                if (status === "Finalizado") {
                                    permitirEditar = false;
                                    colorBg = "#e5fde5";
                                }

                                let colorTitulo = 'info'
                                if (
                                    tituloResposta === "Múltiplos títulos encontrados com divergências na cobrança" ||
                                    tituloResposta === "Títulos encontrados com divergências"
                                ) colorTitulo = "#ef7918"

                                if (
                                    tituloResposta === "Múltiplos títulos encontrados na cobrança" ||
                                    tituloResposta === "Título encontrado" ||
                                    tituloResposta === "Título selecionado manualmente"
                                ) {
                                    colorTitulo = "primary"
                                }

                                if (tituloResposta === "Título não encontrado") colorTitulo = "error"

                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                            backgroundColor: colorBg,
                                            cursor: (somenteVisualizacao || status === "Finalizado" || !permitirEditar) ? 'default' : 'pointer',
                                            '&:hover': {
                                                backgroundColor: darken(colorBg, 0.1),
                                            },
                                        }}
                                        onClick={() => {
                                            if (!somenteVisualizacao && status !== "Finalizado" && permitirEditar) {
                                                setOpenModalTitulo({
                                                    idRow: row.id,
                                                    titulos_possiveis: resumo.titulos_possiveis,
                                                    totais: {
                                                        total_cobrancas: resumo.total_cobrancas,
                                                        total_possiveis: resumo.total_possiveis
                                                    }
                                                })
                                            }
                                        }}
                                    >
                                        <TableCell>{resumo.seu_numero}</TableCell>
                                        <TableCell>{resumo.data_ocorrencia ? moment(resumo.data_ocorrencia).format("DD/MM/YYYY") : "-"}</TableCell>
                                        <TableCell align="right" >{formatarValorMonetario(resumo.valor)}</TableCell>
                                        <TableCell align="right" >{formatarValorMonetario(saldoSimuladoArredondado)}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario(resumo.valor_recebido)}</TableCell>
                                        <TableCell>{resumo.nome_pagador}</TableCell>
                                        <TableCell>{resumo.ocorrencia_descricao}</TableCell>

                                        <TableCell >
                                            <Typography variant="subtitle2" color={colorTitulo}>
                                                {resumo.resposta}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        <TableCell >
                                            <Typography variant="subtitle2" color={colorTitulo} >
                                                {resumo.titulo ? 
                                                    (typeof resumo.titulo === 'string' && 
                                                     (resumo.titulo.startsWith('[') || resumo.titulo.includes('"')) ? 
                                                        resumo.titulo.replace(/[\[\]"\\]/g, '') : 
                                                        resumo.titulo) 
                                                    : "-"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    }
                    {
                        rowsToRender.length === 0 &&
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={17} align="center">
                                    <DataSemResultados size="medium" texto="Nenhum resultado encontrado" />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
            </TableContainer>

            {
                openModalTitulo &&
                <ModalDetalheTituloProvider>
                    <DialogAnalisarTitulosCnab240
                        open={Boolean(openModalTitulo.idRow)}
                        opcoes={openModalTitulo.titulos_possiveis}
                        totais={openModalTitulo.totais}
                        handleClose={() => setOpenModalTitulo(null)}
                    />
                </ModalDetalheTituloProvider>
            }
        </Box>
    )
}

interface TTableDadosCNAB240Props {
    tipo: string;
    rows: Ocorrencia[],
    somenteVisualizacao: boolean,
    handleAlterarLinha: (id: number, titulo?: string, observacao?: string) => void
}

interface IOpenModal {
    idRow: number;
    totais: {
        total_cobrancas: number;
        total_possiveis: number;
    }
    titulos_possiveis: TTitulosCnab240[]
}

